import common from './common/es';
import exhibitors from './exhibitors/es';
import visitors from './visitors/es';
import managers from './managers/es';

export default {
  common,
  exhibitors,
  visitors,
  managers,
};
